import React from 'react';

const ConcentricCircles = ({
  circleCount = 3,
  minRadius = 50,
  spacing = 30,
  baseFontSize = 40,
  fontSizeDecreaseFactor = 0,
  fontWeight = 400,
  colors = ['#ff5454', '#27ff8c', '#b75fff'], // 默认颜色
  svgWidth = 1000,
  svgHeight = 1000,
}) => {
  const letters = ['M', 'N', 'H']; // 默认字母

  const drawCircles = () => {
    let elements = [];
    let currentRadius = minRadius;

    for (let i = 0; i < circleCount; i++) {
      const letterIndex = i % letters.length;
      const colorIndex = i % colors.length;
      const currentLetter = letters[letterIndex];
      const currentLettersCount = 6 * Math.pow(2, i);
      const angleStep = (2 * Math.PI) / currentLettersCount;
      const currentFontSize = Math.max(5, baseFontSize - i * fontSizeDecreaseFactor * i);

      let circleElements = [];

      for (let j = 0; j < currentLettersCount; j++) {
        const angle = j * angleStep;
        const x = svgWidth / 2 + currentRadius * Math.cos(angle);
        const y = svgHeight / 2 + currentRadius * Math.sin(angle);
        const rotationAngle = (angle * 180) / Math.PI + 90;

        circleElements.push(
          <text
            key={`letter-${i}-${j}`}
            x={x}
            y={y}
            fill={colors[colorIndex]} // 确保 colors 不为空
            fontSize={currentFontSize}
            fontWeight={fontWeight}
            textAnchor="middle"
            dominantBaseline="central"
            style={{ userSelect: 'none' }}
            transform={`rotate(${rotationAngle}, ${x}, ${y})`}
          >
            {currentLetter}
          </text>
        );
      }

      elements.push(...circleElements);
      currentRadius += spacing;
    }

    return elements;
  };

  return (
    <svg id="concentric-svg" width={svgWidth} height={svgHeight} style={{ backgroundColor: 'black' }}>
      {drawCircles()}
    </svg>
  );
};

export default ConcentricCircles;
